<template>
  <div class="widget">
    <div class="tabs-left">
      <ul class="nav nav-tabs" role="tablist">
        <li role="presentation" class="nav-item" :class="{ active: activeName == 'first' }">
          <span class="nav-link" role="tab" @click="activeName = 'first'" data-toggle="tab">
            <img class="dashboard-icons" src="/static/images/icons/submission_icon_blue.svg" />
            Project Status
          </span>
        </li>
        <li role="presentation" class="nav-item" :class="{ active: activeName == 'second' }">
          <span class="nav-link" role="tab" @click="activeName = 'second'" data-toggle="tab">
            <img class="dashboard-icons" src="/static/images/icons/submission_icon_blue.svg" />
            Project Type
          </span>
        </li>
      </ul>
      <pie-chart :isCombo="true" v-if="activeName == 'first'" :sbData="sbData"></pie-chart>
      <project-type Initialtitle="" v-if="activeName == 'second'" :sbData="sbData"></project-type>
    </div>
  </div>
</template>
<script>
import PieChart from './PieChart.vue';
import ProjectType from './ProjectType.vue';

export default {
  props: ['sbData'],
  data() {
    return {
      activeName: 'first',
    };
  },
  components: {
    PieChart,
    ProjectType,
  },
  methods: {},
};
</script>
<style scoped>
ul.nav-tabs > li {
  margin-right: 40px;
  padding-bottom: 14px;
  font-size: 22px;
  font-weight: 500;
  line-height: 26px;
}

.widget .active {
  color: #0b3c61;
}
@media only screen and (max-width: 767px) {
  ul.nav-tabs > li {
    margin-right: 18px;
    padding-bottom: 14px;
  }
}
</style>
